import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "text-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = {
  key: 0,
  class: "text-body"
}
const _hoisted_6 = {
  key: 0,
  class: "text-body"
}
const _hoisted_7 = {
  key: 1,
  class: "text-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "header-logo",
        src: require('../../assets/icons/logo-half.svg')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('Contacts.title')), 1)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Loading...", -1)
        ]))]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.country === 'RU')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("p", null, " Кыргызская республика, г.Бишкек, Первомайский р-он, ул. Раззакова, 19. Бц \"Россия\", офис 503 ", -1),
                _createElementVNode("p", null, " ООО \"Моментальные платежи\" ", -1),
                _createElementVNode("br", null, null, -1),
                _createElementVNode("p", null, "Partnership: support@inshop.gg", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("p", null, " CRYSTAL FUTURE OÜ ", -1),
                _createElementVNode("p", null, " Harju maakond, Tallin, Kesklinna linnaosa, Masina tn 22, 10113. ", -1),
                _createElementVNode("br", null, null, -1),
                _createElementVNode("p", null, "Partnership: support@inshop.gg", -1)
              ]))]))
        ], 64))
  ]))
}